var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-in-down"}},[(_vm.isVisible)?_c('div',{staticClass:"login-popup align-center"},[_c('div',{staticClass:"popup-content uppercase bold"},[_c('p',[_vm._v(_vm._s(_vm.message))])])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }